var checkout_exit_intent = (function( $ ) {

	var _init = function() {
		if ( $( 'body.page-template-checkout' ).length > 0 ) {
			// $( document ).on( 'mouseleave', _show_popup );
			$( 'a' ).not( '[target="_blank"], [href^="#"]' ).on( 'click', _show_popup );
		}
	};

	var _show_popup = function( e ) {
		$( 'a' ).not( '[target="_blank"], [href^="#"]' ).off( 'click', _show_popup );
		var popup = '';

		// noinspection JSJQueryEfficiency
		if ( $( '.exit-popup' ).length > 0 || $( '.crate-popup' ).length > 0 ) {
			return;
		}

		if ( 'mouseleave' === e.type ) {
			popup = _get_popup();
		} else {
			e.preventDefault();

			var $anchor = $( this );
			popup = _get_popup( $anchor.attr( 'href' ) );
		}

		var $body = $( 'body' );

		$body.append( popup );
		$body.addClass( 'popup-open' );

		var $popup_overlay = $( '.crate-popup-overlay' );
		// noinspection JSJQueryEfficiency
		var $popup         = $( '.exit-popup' );

		$popup_overlay.fadeIn();
		$popup.fadeIn();
		$popup.addClass( 'open' );

		$popup_overlay.on( 'click', _close_popup );
		$popup.find( 'a.close-popup' ).on( 'click', _close_popup );
		$popup.find( 'a.continue-booking' ).on( 'click', _close_popup );

		$popup.find( 'a.cancel-booking' ).on( 'click', function( e ) {
			e.preventDefault();

			$.removeCookie( '_crate_discount_code', { path : '/' }  );

			window.location.href = $( this ).attr( 'href' );
		} );
	};

	var _close_popup = function( e ) {
		e.preventDefault();

		$( 'a' ).not( '[target="_blank"], [href^="#"]' ).on( 'click', _show_popup );

		$( 'body' ).removeClass( 'popup-open' );

		var $popup = $( '.exit-popup' );
		var $popup_overlay = $( '.crate-popup-overlay' );

		$popup.fadeOut( 400 );
		$popup_overlay.fadeOut( 400 );

		setTimeout( function() {
			$popup.remove();
			$popup_overlay.remove();
		}, 400 );
	};

	var _get_popup = function( url ) {
		var popup = '<div class="crate-popup-overlay"></div>';

		var actions = '<a href="#" class="button continue-booking">Continue Booking</a>';

		if ( url ) {
			actions += '<a href="' + url + '" class="cancel-booking">Cancel Booking</a>';
		}

		popup += '<div class="exit-popup">' +
					'<a href="#" class="close-popup">&times;</a>' +
					'<div class="popup-inner">' +
						'<div class="heading">Are you sure?</div>' +
						'<div class="copy">If you leave now, you\'ll lose any progress made</div>' +
						'<div class="actions">' +
							actions +
						'</div>' +
					'</div>';

		return popup;
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = checkout_exit_intent;